export const icon_calendar_alt_regular = "Fontawesome_icon_calendar_alt_regular "
export const icon_check_solid = "Fontawesome_icon_check_solid "
export const icon_chevron_circle_down_solid = "Fontawesome_icon_chevron_circle_down_solid "
export const icon_clipboard_solid = "Fontawesome_icon_clipboard_solid "
export const icon_cog_solid = "Fontawesome_icon_cog_solid "
export const icon_clock_regular = "Fontawesome_icon_clock_regular "
export const icon_comment_alt_solid = "Fontawesome_icon_comment_alt_solid "
export const icon_dollar_sign_solid = "Fontawesome_icon_dollar_sign_solid "
export const icon_envelope_solid = "Fontawesome_icon_envelope_solid "
export const icon_edit_solid_1 = "Fontawesome_icon_edit_solid_1 "
export const icon_euro_sign_solid_1 = "Fontawesome_icon_euro_sign_solid_1 "
export const icon_exclamation_circle_solid = "Fontawesome_icon_exclamation_circle_solid "
export const icon_eye_solid = "Fontawesome_icon_eye_solid "
export const icon_save_solid = "Fontawesome_icon_save_solid "
export const icon_question_solid = "Fontawesome_icon_question_solid "
export const icon_plus_solid = "Fontawesome_icon_plus_solid "
export const icon_phone_solid = "Fontawesome_icon_phone_solid "
export const icon_pencil_alt_solid = "Fontawesome_icon_pencil_alt_solid "
export const icon_paperclip_solid = "Fontawesome_icon_paperclip_solid "
export const icon_palette_solid = "Fontawesome_icon_palette_solid "
export const icon_music_solid = "Fontawesome_icon_music_solid "
export const icon_map_marker_alt_solid = "Fontawesome_icon_map_marker_alt_solid "
export const icon_list_solid = "Fontawesome_icon_list_solid "
export const icon_link_solid = "Fontawesome_icon_link_solid "
export const icon_info_solid = "Fontawesome_icon_info_solid "
export const icon_hashtag_solid = "Fontawesome_icon_hashtag_solid "
export const icon_square_regular = "Fontawesome_icon_square_regular "
export const icon_trash_alt_solid = "Fontawesome_icon_trash_alt_solid "
export const icon_umbrella_beach_solid = "Fontawesome_icon_umbrella_beach_solid "
export const icon_undo_solid = "Fontawesome_icon_undo_solid "
export const icon_user_plus_solid = "Fontawesome_icon_user_plus_solid "
export const icon_user_solid = "Fontawesome_icon_user_solid "
export const icon_birthday_cake = "Fontawesome_icon_birthday_cake "
export const icon_sticky_note = "Fontawesome_icon_sticky_note "
export const icon_play = "Fontawesome_icon_play "
export const icon_search = "Fontawesome_icon_search "
export const icon_house = "Fontawesome_icon_house "
export const icon_chart = "Fontawesome_icon_chart "
export const icon_thumbtack = "Fontawesome_icon_thumbtack "
export const icon_arrow_left = "Fontawesome_icon_arrow_left "
export const icon_arrow_right = "Fontawesome_icon_arrow_right "
export const icon_family = "Fontawesome_icon_family "
export const icon_glasses = "Fontawesome_icon_glasses "
export const icon_building = "Fontawesome_icon_building "
export const icon_expand = "Fontawesome_icon_expand "
export const icon_compress = "Fontawesome_icon_compress "